// Convert kebab-case to camelCase
function toCamelCase(str) {
  return str.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
}

// Format money from cents using Shopify's money format
// This function formats cents (number) to currency string
function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const value = Number(cents);

  const moneyFormat =
    format ||
    window.theme?.moneyFormat ||
    (window.Shopify && window.Shopify.money_format) ||
    '${{amount_with_comma_separator}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number === null) return '0';

    const fixed = (number / 100).toFixed(precision);
    const [dollars, centsPart] = fixed.split('.');
    const dollarsWithThousands = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

    return centsPart ? `${dollarsWithThousands}${decimal}${centsPart}` : dollarsWithThousands;
  }

  const placeholderMatch = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
  const placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';

  let formatted;

  switch (placeholder) {
    case 'amount':
      formatted = formatWithDelimiters(value, 2, ',', '.');
      break;
    case 'amount_no_decimals':
      formatted = formatWithDelimiters(value, 0, ',', '.');
      break;
    case 'amount_with_comma_separator':
      formatted = formatWithDelimiters(value, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      formatted = formatWithDelimiters(value, 0, '.', ',');
      break;
    case 'amount_with_space_separator':
      formatted = formatWithDelimiters(value, 2, ' ', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      formatted = formatWithDelimiters(value, 0, ' ', ',');
      break;
    default:
      formatted = formatWithDelimiters(value, 2, ',', '.');
  }

  return moneyFormat.replace(placeholderMatch[0], formatted);
}

// Make functions available globally
if (typeof window !== 'undefined') {
  window.toCamelCase = toCamelCase;
  window.formatMoney = formatMoney;
}